function isHTMLString(response: string): boolean {
  const trimmed = response.trim()

  return /^<[^>]+>[\s\S]*<\/[^>]+>$/.test(trimmed)
}

export { isHTMLString }
